import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import AppLayout from './App';  // Assuming AppLayout is your main layout component
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ScrollToTop from "./../src/components/common/scrollTop";

import Home from './components/Home/home.component';
import About from './components/About/about.component';
import Contact from './components/Contact/contact.component';
import Pricing from './components/Pricing/pricing.component';
import Appointment from './components/Appointment/appointment.component';
import Thanks from './components/ThankYou/thanks.component';
import BookingStatus from './components/BookingStatus/booking-status.component';
import NotFound from './components/NotFound/notFound.component';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from './components/Login/login.component';
import Dashboard from './components/Dashboard/dashboard.component';
import DashboardLayout from './components/Dashboard/layout';
import Categories from './components/Categories/categories.component';
import SubCategories from './components/SubCategories/subcategories';
import Bookings from './components/Bookings/booking';
import OpenBookings from './components/Bookings/open-bookings';
import ConfirmedBookings from './components/Bookings/confirmed-bookings';
import AddCategory from './components/Categories/add-category.component';
import AddSubCategory from './components/SubCategories/add-subcategory.component';
import EditCategory from './components/Categories/edit-category.component';
import EditSubCategory from './components/SubCategories/edit-subcategory.component';
import BookingDetails from './components/Bookings/booking-details';
import "./components/common/http-interceptor";
import PrivateRoute from "./components/common/protected-route"
import PublicRoute  from "./components/common/public-route"
import ChangePassword from './components/ChangePassword/change-password.component';
import BlockDates from './components/BlockDates/blockDates.component';
import PagesList from './components/Page_Settings/page_settings';
import EmailSettings from './components/EmailSettings/email-settings.component';
import CustomerImages from './components/CustomerImages/customer-images.component';
import AddCustomerImage from './components/CustomerImages/add-image.component';
import ReviewsList from './components/Reviews/reviews.component';
import GiftCardList from './components/GiftCardsCustomer/gift-card.component';
import Promotions from './components/Promotions/promotions';
import Review from './components/Review/review.component';
import CustomerReviews from './components/CustomerReviews/customer-reviews.component';
import BookingQuestions from './components/BookingQuestions/booking-questions.component';
import AddBookingQuestion from './components/BookingQuestions/add-booking-question.component';
import EditBookingQuestion from './components/BookingQuestions/edit-booking-question.component';
import SeoPages from './components/SeoPages/seo-pages.component';
import SeoPageForm from './components/SeoPages/seo-page-form.component';
import SeoPageDisplay from './components/SeoPage/seo-page-display.component';
import Services from './components/Services/services.component';
import Users from './components/Dashboard/users.component';
import SquareSettings from './components/Dashboard/square-settings.component';

function Routing() {
  return (
    <Router>
            <ScrollToTop />
            
      <Routes>
        {/* Main layout with nested routes example */}
        
        <Route path="/" element={<AppLayout />}>
          {/* Default home route */}
         
          <Route index element={<Home />} />
          <Route path='/about' element={<About />} />
          <Route path='/contact' element={<Contact />} />
          <Route path='/pricing' element={<Pricing />} />
          <Route path='/services' element={<Services />} />
           <Route path='/book-appointment' element={<Appointment />} />
            <Route path='/thank-you' element={<Thanks />} />
             <Route path='/booking-status' element={<BookingStatus />} />
              <Route path='/gift-cards' element={<GiftCardList />} />
              <Route path='/review' element={<Review />} />
              <Route path='/reviews' element={<CustomerReviews />} />
              <Route path='/:slug' element={<SeoPageDisplay />} />

      <Route  path="*" element={<NotFound />} />
      

          {/* You can add more nested routes here */}
        </Route>
       <Route
  path="/login"
  element={
    <PublicRoute>
      <Login />
    </PublicRoute>
  }
/>
          <Route path="/" element={<PrivateRoute />}>
          <Route  element={<DashboardLayout />} >
             <Route path='dashboard' element={<Dashboard />} />
             <Route path='categories' element={<Categories />} />
              <Route path='sub-categories' element={<SubCategories />} />
              <Route path='bookings' element={<Bookings />} />
              <Route path='open-bookings' element={<OpenBookings />} />
              <Route path='confirmed-bookings' element={<ConfirmedBookings />} />
              <Route path='users' element={<Users />} />
              <Route path='booking-questions' element={<BookingQuestions />} />
              <Route path='add-booking-question' element={<AddBookingQuestion />} />
              <Route path='edit-booking-question' element={<EditBookingQuestion />} />
              <Route path='seo-pages' element={<SeoPages />} />
              <Route path='add-seo-page' element={<SeoPageForm />} />
              <Route path='edit-seo-page' element={<SeoPageForm />} />
              <Route path='add-category' element={<AddCategory />} />
              <Route path='add-subcategory' element={<AddSubCategory />} />
                <Route path='edit-category' element={<EditCategory />} />
                  <Route path='edit-subcategory' element={<EditSubCategory />} />
          <Route path='booking-details' element={<BookingDetails />} />
        <Route path='change-password' element={<ChangePassword />} />
 <Route path='block-dates' element={<BlockDates />} />
  <Route path='page-settings' element={<PagesList />} />
  <Route path='email-settings' element={<EmailSettings />} />
  <Route path='square-settings' element={<SquareSettings />} />
<Route path='customer-images' element={<CustomerImages />} />
<Route path='add-image' element={<AddCustomerImage />} />
<Route path='reviewsListing' element={<ReviewsList />} />

 <Route path='/promotions' element={<Promotions />} />
  
  
          </Route>
          </Route>
      </Routes>
           <ToastContainer
            hideProgressBar={false}
            autoClose={5000}
            pauseOnHover={true}
          />
    </Router>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Routing />
  </React.StrictMode>
);

reportWebVitals();
